// Local-calendar date helpers. Never build a date string with toISOString(): it is UTC, a day behind in India after midnight.
export const localDate = (d = new Date()) => {
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
};

export const monthStart = (d = new Date()) => localDate(new Date(d.getFullYear(), d.getMonth(), 1));
export const monthEnd = (d = new Date()) => localDate(new Date(d.getFullYear(), d.getMonth() + 1, 0));

export const addDays = (iso, days) => {
  const [y, m, d] = iso.split('-').map(Number);
  return localDate(new Date(y, m - 1, d + days));
};

export const fmtDate = (iso) => {
  if (!iso) return '-';
  const [y, m, d] = String(iso).substring(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
